import {useSelector} from 'react-redux';
import {ReduxState} from '../store/types';
import {useMemo} from 'react';
import {extensionPlanFormDefaultValues} from '../components/Forms/Extensions/PlanForm.utils';

export const useAccountPlanFormData = () => {
    const accountDetails = useSelector(
        (state: ReduxState) => state.accounts.accountDetails,
    );

    const { products } = useSelector((state: ReduxState) => state.extensions);

    const initFormData = useMemo(() => {
        if (!accountDetails) {
            return extensionPlanFormDefaultValues;
        }
        return {
            selectedMainProduct: accountDetails.i_product ?? -1,
            selectedAddonsProducts:
                (accountDetails as any).assigned_addons?.map(
                    (v: { i_product: number }) => v.i_product,
                ) || [],
        };
    }, [accountDetails, products]);

    return {
        initFormData,
        data: {
            i_account: accountDetails?.i_account,
        },
    };
};